import { useState } from 'react';

export interface CepLookupResult {
  endereco?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
}

/** Busca endereço via ViaCEP. */
export function useCepLookup() {
  const [buscando, setBuscando] = useState(false);
  const [erro, setErro] = useState('');

  async function buscar(cepRaw: string): Promise<CepLookupResult | null> {
    const cep = cepRaw.replace(/\D/g, '');
    if (cep.length !== 8) {
      setErro('CEP inválido (8 dígitos)');
      return null;
    }
    setErro('');
    setBuscando(true);
    try {
      const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const d = await res.json();
      if (d.erro) {
        setErro('CEP não encontrado');
        return null;
      }
      return { endereco: d.logradouro, bairro: d.bairro, cidade: d.localidade, estado: d.uf };
    } catch {
      setErro('Erro ao buscar CEP.');
      return null;
    } finally {
      setBuscando(false);
    }
  }

  return { buscar, buscando, erro, setErro };
}
